import { useCallback, useMemo } from "react";
import styled from "styled-components";
import { ArrowRightIcon, FlagIcon } from "@heroicons/react/24/outline";
import { Button, Warning } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { policy } from "@sablier/v2-machines";
import { _ } from "@sablier/v2-mixins";
import { vendors } from "@sablier/v2-utils";
import { Card } from "~/client/components/molecules";
import { useMachineCreateProxy, useModalProxy } from "~/client/hooks";

const Wrapper = styled(Card)``;

const Content = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    width: 100%;
    & > * {
      width: 100%;
    }
  }
`;

const About = styled.div`
  & > p {
    ${(props) => props.theme.styles.textParagraph}
    & {
      color: ${(props) => props.theme.colors.gray400};
    }
  }
`;

function Proxy() {
  const { machine } = useMachineCreateProxy();
  const { doOpen: openProxyModal } = useModalProxy();
  const { t } = useT();
  const error = useMemo(
    () =>
      !_.isNilOrEmptyString(machine.context.error)
        ? policy.error.message(t, machine.context.error)
        : undefined,
    [machine.context.error, t],
  );

  const doOpen = useCallback(() => {
    vendors.track.log("clickOnCreateProxyAccount");
    openProxyModal();
  }, [openProxyModal]);

  return (
    <Wrapper isTopHidden>
      <Content>
        <About>
          <p>{t("structs.createProxyInfo")}</p>
        </About>
        <Button
          accent={"white"}
          appearance={"solid"}
          onClick={doOpen}
          right={ArrowRightIcon}
          left={FlagIcon}
          title={t("structs.createProxyAction")}
        />
        <Warning value={error} />
      </Content>
    </Wrapper>
  );
}

export default Proxy;
